import React from "react";

export const Footer = () => {
  return (
    <div id="footer">
      <div className="container text-center">
        <p>2024 - Text Restore &copy;</p>
        <p>All Rights Reserved</p>
      </div>
    </div>
  );
};
